import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
export default {
  listProduct (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemBarcode (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/barcode', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemById (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/id', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemByIdMe (URL, header, body, success, error) {
    Vue.axios.post(URL, body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listProductByConfig (URL, header, body, success, error) {
    Vue.axios.post(URL, body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemAdd (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/new', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        // console.log(error.response.data.error)
        error(response.response)
      }
    )
  },
  itemUnit (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/unit', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemType (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/type', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemGroup (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/group', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemDepartment (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/department', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemCatagory (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/category', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  itemsALLGroup (URL, header, body, success, error) {
    Vue.axios.post(URL + 'product/v1/item/search/group', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  createReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'receive/v1/create/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'receive/v1/update/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'receive/v1/remove/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'receive/v1/list/receive', body, header).then(
      response => {
        console.log(response)
        success(response.data)
      },
      response => {
        console.log(response)
        error(response)
      }
    )
  },
  getReceive (URL, header, body, success, error) {
    Vue.axios.post(URL + 'receive/v1/get/receive', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  createAdjust (URL, header, body, success, error) {
    Vue.axios.post(URL + 'adjust/v1/create/adjust', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getAdjust (URL, header, body, success, error) {
    Vue.axios.post(URL + 'adjust/v1/get/adjust', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  listAdjust (URL, header, body, success, error) {
    Vue.axios.post(URL + 'adjust/v1/list/adjust', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeAdjust (URL, header, body, success, error) {
    Vue.axios.post(URL + 'adjust/v1/remove/adjust', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateAdjust (URL, header, body, success, error) {
    Vue.axios.post(URL + 'adjust/v1/update/adjust', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  recalStock (URL, header, body, success, error) {
    // {
    // "item_code":""
    // }
    Vue.axios.post(URL + 'stock/v1/re/stock', body, header).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_item.js